import Handlebars from 'handlebars';

export const templates: Record<string, Handlebars.TemplateDelegate> = {
  defaultTemplate: Handlebars.template({
    compiler: [8, '>= 4.3.0'],
    main: function (
      container: {
        lookupProperty: (parent: any, propertyName: any) => any;
        escapeExpression: (arg0: any) => any;
        hooks: { helperMissing: any };
        nullContext: any;
      },
      depth0: null,
      helpers: any,
      partials: any,
      data: any
    ) {
      const lookupProperty =
        container.lookupProperty ||
        function (parent: { [x: string]: any }, propertyName: string | number) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return;
        };

      return container.escapeExpression(
        (
          lookupProperty(helpers, 'first') ||
          (depth0 && lookupProperty(depth0, 'first')) ||
          container.hooks.helperMissing
        ).call(
          depth0 == null ? container.nullContext || {} : depth0,
          depth0 == null ? depth0 : lookupProperty(depth0, 'answers'),
          {
            name: 'first',
            hash: {},
            data: data,
            loc: {
              start: { line: 1, column: 0 },
              end: { line: 1, column: 17 },
            },
          }
        )
      );
    },
    useData: true,
  }),
  enumTemplate: Handlebars.template({
    compiler: [8, '>= 4.3.0'],
    main: function (
      container: {
        nullContext: any;
        hooks: { helperMissing: any };
        lookupProperty: (parent: any, propertyName: any) => any;
        escapeExpression: (arg0: any) => any;
      },
      depth0: null,
      helpers: any,
      partials: any,
      data: any
    ) {
      const alias1 = depth0 == null ? container.nullContext || {} : depth0,
        alias2 = container.hooks.helperMissing,
        lookupProperty =
          container.lookupProperty ||
          function (
            parent: { [x: string]: any },
            propertyName: string | number
          ) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }
            return;
          };

      return container.escapeExpression(
        (
          lookupProperty(helpers, 'enum') ||
          (depth0 && lookupProperty(depth0, 'enum')) ||
          alias2
        ).call(
          alias1,
          (
            lookupProperty(helpers, 'first') ||
            (depth0 && lookupProperty(depth0, 'first')) ||
            alias2
          ).call(
            alias1,
            depth0 == null ? depth0 : lookupProperty(depth0, 'answers'),
            {
              name: 'first',
              hash: {},
              data: data,
              loc: {
                start: { line: 1, column: 7 },
                end: { line: 1, column: 22 },
              },
            }
          ),
          {
            name: 'enum',
            hash: {},
            data: data,
            loc: {
              start: { line: 1, column: 0 },
              end: { line: 1, column: 24 },
            },
          }
        )
      );
    },
    useData: true,
  }),
  dateTemplate: Handlebars.template({
    compiler: [8, '>= 4.3.0'],
    main: function (
      container: {
        nullContext: any;
        hooks: { helperMissing: any };
        lookupProperty: (parent: any, propertyName: any) => any;
        escapeExpression: (arg0: any) => any;
      },
      depth0: null,
      helpers: any,
      partials: any,
      data: any
    ) {
      const alias1 = depth0 == null ? container.nullContext || {} : depth0,
        alias2 = container.hooks.helperMissing,
        lookupProperty =
          container.lookupProperty ||
          function (
            parent: { [x: string]: any },
            propertyName: string | number
          ) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }
            return;
          };

      return container.escapeExpression(
        (
          lookupProperty(helpers, 'date') ||
          (depth0 && lookupProperty(depth0, 'date')) ||
          alias2
        ).call(
          alias1,
          (
            lookupProperty(helpers, 'first') ||
            (depth0 && lookupProperty(depth0, 'first')) ||
            alias2
          ).call(
            alias1,
            depth0 == null ? depth0 : lookupProperty(depth0, 'answers'),
            {
              name: 'first',
              hash: {},
              data: data,
              loc: {
                start: { line: 1, column: 7 },
                end: { line: 1, column: 22 },
              },
            }
          ),
          'MM/DD/YYYY',
          {
            name: 'date',
            hash: {},
            data: data,
            loc: {
              start: { line: 1, column: 0 },
              end: { line: 1, column: 37 },
            },
          }
        )
      );
    },
    useData: true,
  }),
  translateTemplate: Handlebars.template({
    compiler: [8, '>= 4.3.0'],
    main: function (
      container: {
        nullContext: any;
        hooks: { helperMissing: any };
        lookupProperty: (parent: any, propertyName: any) => any;
        escapeExpression: (arg0: any) => any;
      },
      depth0: null,
      helpers: any,
      partials: any,
      data: any
    ) {
      const alias1 = depth0 == null ? container.nullContext || {} : depth0,
        alias2 = container.hooks.helperMissing,
        lookupProperty =
          container.lookupProperty ||
          function (
            parent: { [x: string]: any },
            propertyName: string | number
          ) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }
            return;
          };

      return container.escapeExpression(
        (
          lookupProperty(helpers, 'translate') ||
          (depth0 && lookupProperty(depth0, 'translate')) ||
          alias2
        ).call(
          alias1,
          (
            lookupProperty(helpers, 'first') ||
            (depth0 && lookupProperty(depth0, 'first')) ||
            alias2
          ).call(
            alias1,
            depth0 == null ? depth0 : lookupProperty(depth0, 'answers'),
            {
              name: 'first',
              hash: {},
              data: data,
              loc: {
                start: { line: 1, column: 12 },
                end: { line: 1, column: 27 },
              },
            }
          ),
          {
            name: 'translate',
            hash: {},
            data: data,
            loc: {
              start: { line: 1, column: 0 },
              end: { line: 1, column: 29 },
            },
          }
        )
      );
    },
    useData: true,
  }),
  formatAddressTemplate: Handlebars.template({
    compiler: [8, '>= 4.3.0'],
    main: function (
      container: {
        lookupProperty: (parent: any, propertyName: any) => any;
        escapeExpression: (arg0: any) => any;
        hooks: { helperMissing: any };
        nullContext: any;
      },
      depth0: null,
      helpers: any,
      partials: any,
      data: any
    ) {
      const lookupProperty =
        container.lookupProperty ||
        function (parent: { [x: string]: any }, propertyName: string | number) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return;
        };

      return container.escapeExpression(
        (
          lookupProperty(helpers, 'formatAddress') ||
          (depth0 && lookupProperty(depth0, 'formatAddress')) ||
          container.hooks.helperMissing
        ).call(
          depth0 == null ? container.nullContext || {} : depth0,
          depth0 == null ? depth0 : lookupProperty(depth0, 'street'),
          depth0 == null ? depth0 : lookupProperty(depth0, 'city'),
          depth0 == null ? depth0 : lookupProperty(depth0, 'state'),
          depth0 == null ? depth0 : lookupProperty(depth0, 'zip'),
          {
            name: 'formatAddress',
            hash: {},
            data: data,
            loc: {
              start: { line: 1, column: 0 },
              end: { line: 1, column: 39 },
            },
          }
        )
      );
    },
    useData: true,
  }),
};
